import store from ".";
import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import Auth from "@aws-amplify/auth";

export interface AccountInfoState {
  currentUserInfo: any;
  isLoggedIn: boolean;
  isAdmin: boolean;
}

@Module({ dynamic: true, store, name: "accountInfo", namespaced: true })
class AccountInfo extends VuexModule implements AccountInfoState {
  currentUserInfo: any = {};
  @Mutation
  public SET_CURRENT_USER_INFO(currentUserInfo: any) {
    this.currentUserInfo = currentUserInfo;
  }
  @Action({}) public async getCurrentUserInfo() {
    try {
      const userInfo = await Auth.currentAuthenticatedUser();
      this.SET_CURRENT_USER_INFO(userInfo);
      return userInfo;
    } catch (e) {
      return {};
    }
  }
  get getUserInfo() {
    return this.currentUserInfo;
  }
  get isLoggedIn(): boolean {
    return Object.keys(this.currentUserInfo).length != 0;
  }
  get isAdmin(): boolean {
    try {
      return this.groups.indexOf("admin") >= 0;
    } catch (e) {
      return false;
    }
  }
  get getUserId(): string {
    return this.currentUserInfo["attributes"]["sub"];
  }
  get getEmail(): string {
    return this.currentUserInfo["attributes"]["email"];
  }
  get groups(): Array<string> {
    try {
      if (this.currentUserInfo["signInUserSession"]["idToken"]["payload"]["cognito:groups"]) {
        return this.currentUserInfo["signInUserSession"]["idToken"]["payload"]["cognito:groups"];
      }
      return [];
    } catch (e) {
      return [];
    }
  }
}
export const accountInfoModule = getModule(AccountInfo);
